// extracted by mini-css-extract-plugin
export default {"view":"styles_view__40jHb","cell":"styles_cell__YyqBp","label":"styles_label__yY2qd"};